import { Controller } from "@hotwired/stimulus"

// Article page: shows the compact reading bar once the body scrolls into
// view and fills its progress line as the body is read.
export default class extends Controller {
  static targets = ["bar", "progress", "body"]

  connect() {
    this.update = this.update.bind(this)
    window.addEventListener("scroll", this.update, { passive: true })
    window.addEventListener("resize", this.update, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.update)
    window.removeEventListener("resize", this.update)
  }

  update() {
    const rect = this.bodyTarget.getBoundingClientRect()
    const read = -rect.top / Math.max(1, rect.height - window.innerHeight)
    this.progressTarget.style.width = `${Math.min(1, Math.max(0, read)) * 100}%`
    this.barTarget.classList.toggle("is-visible", rect.top < 200)
  }
}
